var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"100%","height":"269","viewBox":"0 0 1920 269"}},[_c('path',{attrs:{"id":"Path_4","data-name":"Path 4","d":"M0,80.249C0,14.875,0,14.262,0,0H1920V254l-142.3,8.5s-143.53,7.344-229.68,6.418c-167.98-1.806-299.93-4.109-299.93-4.109l-190.45-7.365L864.95,248.1,654.4,234.774,434.462,220.506s-164.583-7.742-222.142-6.174C117.807,216.9.046,234.286.046,234.286Z","fill":_vm.color}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589af462","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/Head.vue
// module id = So9v
// module chunks = 0